import rosterService from './roster';
import { getValidDyslexiaAssessmentsForStudents, getUserData, filterDyslexiaAssessments } from "../../../services/API"; // placeholder
import types from '../state/dyslexia/constants';
import actions from '../state/dyslexia/actions';

export function fetchScores (classroomId, window, cachedDyslexiaData, dispatch) {
  return rosterService.fetchRoster('student',classroomId, cachedDyslexiaData).then((students) => {
    dispatch(actions[types.DYSLEXIA_CACHE_SAVE]({classroomId, students}))
    if(!Array.isArray(students) || students.length == 0 || !getUserData().dyslexiaEnabled) {
      return [];
    }

    return getValidDyslexiaAssessmentsForStudents(students, cachedDyslexiaData, 10).then((activities) => {
      const activitiesForSelectedWindow = filterDyslexiaAssessments(students, activities, window)
      dispatch(actions[types.DYSLEXIA_CACHE_SAVE]({classroomId, activities}))
      // map activities to a "scores" data format that benchmark will ingest
      let scores = activitiesForSelectedWindow.map((activity, i) => {
        if(activity.scores) {
          const rawScore = activity.scores.dyslexiaRiskIndicator;
          const integerPart = Math.floor(rawScore);
          const roundedScore = integerPart === 29 ? Math.floor(rawScore) : Math.round(rawScore);
          return {
            ...activity.student,
            studentId: activity.student.id,
            id: activity.activityId,
            dyslexiaRiskCategory: activity.scores.dyslexiaRiskCategory,
            status: activity.status,
            displayStatus: activity.displayStatus,
            score: roundedScore,
            rawScore: rawScore,
            labeledScore: '',
            tags: activity.tags,
            activityDate: activity.createdAt,
          };
        }
      });
      scores = scores.filter(function (el) {
        return el != null;
      });
      return scores;
    }, (error) => {
      console.error(error);
    });
  }, (error) => {
      console.error(error);
  });

}

export default {
  fetchScores,
}